import { get, post, patch, deletes } from '@_shared/config';
import {
	IContentDetail,
	IContent,
	IPostContentRequest,
	IContentListResponse,
	TContentListOrder,
} from '../model';

export async function create(props: IPostContentRequest) {
	const { data } = await post('/content', props);
	return data;
}

export async function getContent(id: IContent['id']) {
	return get<IContentDetail>(`/content/${id}`);
}

export async function updateMemo(id: IContent['id'], memo: IContentDetail['memo']) {
	return patch(`/content/${id}`, {
		memo,
	});
}

export async function updateTitle(id: IContent['id'], title: string) {
	return patch(`/content/${id}`, {
		title,
	});
}

export async function updateFolder(id: IContent['id'], folderId: IContentDetail['folderId']) {
	return patch(`/content/${id}`, {
		folderId,
	});
}

export async function updateContentListFolder(
	contentIds: number[],
	folderId: IContentDetail['folderId'],
) {
	return patch('/content/bulk', {
		contentIds,
		folderId,
	});
}

export async function remove(id: number) {
	return deletes(`/content/${id}`);
}

export async function removeList(ids: number[]) {
	return deletes(`/content/bulk`, {
		contentIds: ids,
	});
}

export async function search(keyword: string, order?: TContentListOrder, folderId?: string) {
	return get<IContentListResponse>(
		`/content?order=${order === undefined ? 'latest' : order}&keyword=${keyword}${folderId ? `&folder=${folderId}` : ''}`,
	);
}

export async function pinContent(id: number, pinType: 'folder' | 'entire', folderId?: number) {
	return post(`/content/pin`, {
		contentId: id,
		pinType,
		folderId,
	});
}

export async function unPinContent(id: number, pinType: 'folder' | 'entire', folderId?: number) {
	return deletes(`/content/pin`, {
		contentId: id,
		pinType,
		folderId,
	});
}
